/**
 * Supply Lines — Sir Pent's unlock (MINIGAME_PROPOSALS O7). You beat a train;
 * you keep the rails. Cleared 10-wave segments become depots on a map; Scrap
 * lays track between adjacent depots. Connected depots pay +1 percent Scrap
 * each, completed loops +2 percent each, hard-capped at +25 percent.
 *
 * Design call: multiplicative Scrap with a LOW ceiling (the pets pattern).
 * A management toy, not a math engine.
 */

/** Depots per map row (the snake-grid width). */
export const RAIL_GRID_W = 6;

/** Income bonus per connected depot / per completed loop, and the hard cap. */
export const RAIL_PER_DEPOT = 0.01;
export const RAIL_PER_LOOP = 0.02;
export const RAIL_CAP = 0.25;

/** Scrap cost factor for a route (× waveScrap of the farther depot's boss wave). */
export const RAIL_COST_MULT = 25;

/** Derailments: rolled once per this period; a hit knocks one route out. */
export const DERAIL_CHECK_MS = 60_000;
export const DERAIL_CHANCE = 0.08;
/** A derailed route re-rails itself after this long (idle-safe); a click fixes it instantly. */
export const DERAIL_REPAIR_MS = 10 * 60_000;

/** Grid position of a 1-based depot index (row-major). */
export function depotPos(i: number): { col: number; row: number } {
  return { col: (i - 1) % RAIL_GRID_W, row: Math.floor((i - 1) / RAIL_GRID_W) };
}

/** Depots are linkable when orthogonally adjacent on the grid. */
export function depotsAdjacent(a: number, b: number): boolean {
  if (a === b || a < 1 || b < 1) return false;
  const pa = depotPos(a);
  const pb = depotPos(b);
  return Math.abs(pa.col - pb.col) + Math.abs(pa.row - pb.row) === 1;
}
